import React from "react";
import { LoadingSpinner } from "./LoadingSpinner";

export const FullScreenLoading: React.FC = () => {
  return (
    <div className="bg-primary-900 flex h-screen w-full items-center justify-center">
      <LoadingSpinner size={50} />
    </div>
  );
};
